import {putQuery} from "@/modules/common/utils";

const replaceFile = (uid, file, isTemplate) => {
  const route = isTemplate ? `file_records/${uid}` : `documents/${uid}`;
  const entry = isTemplate ? 'file' : 'files[0][file]';
  const formData = new FormData();
  formData.append(entry, file);
  return putQuery(route, formData);
};

export default {
  replaceFile
};
